export const sendPOST = async (url, headers, data) => {
  let response = await fetch(`${url}`, {
    method: "POST",
    headers: new Headers(headers),
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    throw Error(response);
  } else {
    response = response.json();
    // console.log(response);
    return response;
  }
};

export const sendRequest = async (url, headers, data, method = "GET") => {
  let response;
  if (String(method).toUpperCase() === "GET") {
    response = await fetch(`${url}`, {
      method: "GET",
      headers: new Headers(headers),
    });
  } else {
    response = await fetch(`${url}`, {
      method: method ?? "POST",
      headers: new Headers(headers),
      body: JSON.stringify(data),
    });
  }

  if (!response.ok) {
    throw response;
  } else {
    response = response.json();
    // console.log(response);
    return response;
  }
};

export const loadScript = (path = "") => {
  const script = window.document.createElement("script");
  script.src = path;
  script.async = true;
  document.body.appendChild(script);
};

export function downloadURI(uri, name) {
  var link = document.createElement("a");
  link.target = "_blank";
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
